import hydraHomePageComponentsApiFactory from '../../modules/homePageComponents/hydraHomePageComponentsApi';

/* Utils */
import {
  generateDefaultAsyncWatcher,
  generateDefaultAsyncSaga,
  generateDefaultPollingSaga
} from '../core/reduxUtils';

/* Actions */
import {
  getHydraHomePageComponentsActionCreators,
  getHydraHomePageLazyComponentsActionCreators,
  getHydraHomePageMobileComponentsActionCreators,
  getHydraHomePageMobileLazyComponentActionCreators
} from '../actions/hydraHomePageComponentsActions';

function hydraHomePageComponentsSagasFactory({storefrontApiClient}) {
  const hydraHomePageComponentsApi = hydraHomePageComponentsApiFactory(storefrontApiClient);


  const getHydraHomePageComponents = generateDefaultAsyncSaga(
    hydraHomePageComponentsApi.getHydraHomePageComponents,
    getHydraHomePageComponentsActionCreators,
    payload => [
      payload.params,
    ]
  );

  const getHydraHomePageLazyComponents = generateDefaultAsyncSaga(
    hydraHomePageComponentsApi.getHydraHomePageLazyComponents,
    getHydraHomePageLazyComponentsActionCreators,
    payload => [
      payload.params,
    ]
  );

  const getHydraHomePageMobileComponents = generateDefaultAsyncSaga(
    hydraHomePageComponentsApi.getHydraHomePageMobileComponents,
    getHydraHomePageMobileComponentsActionCreators,
    payload => [
      payload.params,
    ]
  );

  const getHydraHomePageMobileLazyComponent = generateDefaultAsyncSaga(
    hydraHomePageComponentsApi.getHydraHomePageMobileLazyComponent,
    getHydraHomePageMobileLazyComponentActionCreators,
    payload => [
      payload.params,
    ]
  );

  const watchGetHydraHomePageComponents = generateDefaultAsyncWatcher(
    'GET_HYDRA_HOME_PAGE_COMPONENTS',
    getHydraHomePageComponents
  );

  const watchGetHydraHomePageLazyComponents = generateDefaultAsyncWatcher(
    'GET_HYDRA_HOME_PAGE_LAZY_COMPONENTS',
    getHydraHomePageLazyComponents
  );

  const watchGetHydraHomePageMobileComponents = generateDefaultAsyncWatcher(
    'GET_HYDRA_HOME_PAGE_MOBILE_COMPONENTS',
    getHydraHomePageMobileComponents
  );

  const watchGetHydraHomePageMobileLazyComponent = generateDefaultAsyncWatcher(
    'GET_HYDRA_HOME_PAGE_MOBILE_LAZY_COMPONENT',
    getHydraHomePageMobileLazyComponent
  );

  const hydraHomePageComponentsSagas = [
    watchGetHydraHomePageComponents(),
    watchGetHydraHomePageLazyComponents(),
    watchGetHydraHomePageMobileComponents(),
    watchGetHydraHomePageMobileLazyComponent()
  ];

  return hydraHomePageComponentsSagas;
}

export default hydraHomePageComponentsSagasFactory;
